import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/skills', params),
    getById: (id) => Api.get(`/cent/skill/${id}`),
    save: (entity) => Api.post('/cent/skill', entity),
    update: (id, entity) => Api.put('/cent/skill/' + id, entity),
    delete: (id) => Api.delete('/cent/skill/' + id),
    search: (searchText) => Api.get('/cent/skills/search', {q: searchText}),
    getLevelOptions: () => Api.get('/cent/skill/levels'),
    getTypeOptions: () => Api.get('/cent/skill/types'),
    getGroupOptions: () => Api.get('/cent/skill/groups'),
};